import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-form-section',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './form-section.component.html',
  styleUrls: ['./form-section.component.scss']
})
export class FormSectionComponent {
  @Input() title: string = '';
  @Input() icon: string = 'info';
  @Input() iconColor: string = 'blue';
  @Input() sectionClass: string = '';
  @Input() headerClass: string = '';
  @Input() contentClass: string = '';

  get iconColorClass(): string {
    const colorMap: { [key: string]: string } = {
      'blue': 'text-blue-600',
      'green': 'text-green-600',
      'purple': 'text-purple-600',
      'orange': 'text-orange-600',
      'red': 'text-red-600',
      'indigo': 'text-indigo-600',
      'yellow': 'text-yellow-600',
      'gray': 'text-gray-600'
    };
    return colorMap[this.iconColor] || 'text-gray-600';
  }
}